import React, { useEffect, useState } from 'react'
import {Box, Grid, GridItem, Heading, Table,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableContainer,} from '@chakra-ui/react'
import CustomButton from '../../../elements/customButton'
import CustomToast from '../../../elements/customToast'
import { connect, useSelector } from 'react-redux'
import Loader from '../../../elements/loader'
import { bindActionCreators } from 'redux'
import decode from 'jwt-decode';
import { ActionCreators } from '../../../../redux/actions'
import { PINE_PG } from '../../../../constants/Constant'
import { getItem } from '../../../../utilities/authUtils'
import PaymentDialogRegisterFee from '../../../modules/PaymentModule/PaymentDialogRegisterFee'
import ChannelParFeePayDiag from '../../../modules/PaymentModule/ChannelParFeePayDiag'
const OnBoardFeePayment = (props) => {

  const {addToast} = CustomToast()
  const kycState = useSelector((state) => state.kycState)
  const cpState = useSelector((state) => state.cpState)
  const masterState = useSelector((state) => state.masterState)
  const userData = masterState?.getCurrentUserDetails?.data?.data
  const [paymentMethod, setPaymentMethod] = useState(null)
   const user_id_reg =props?.feeData?.id
  const [openPaymentModal, setOpenPaymentModal] = useState(false)
    let amount= props?.feeData?.total_fee_amount 
    const [payableAmount, setPayableAmount] = useState(null)
  useEffect(() => {
    const script = document.createElement("script");
    script.src = PINE_PG;
    script.async = true;
    document.body.appendChild(script);
    props?.actions?.getPaymentMethodsAction()
  }, [])

  useEffect(() => {
    if (cpState?.updateCPOrderStatus?.data?.success === true){
      addToast({message: 'Payment Done Successfully', status: 'success'})
      props?.actions?.getCPUserDetailsByIdAction({user_id: props?.feeData?.id})
      props.onClick()
    }
  }, [cpState?.updateCPOrderStatus])

 
  const handleAddFundsDialog = () => {

    // setPayableAmount(amount)
    if (!props?.feeData?.personal_data) {
      addToast({message: 'Please Complete Personal Details First', status: 'error'})
      return
    }
    if (!props?.feeData?.bank_data) {
      addToast({message: 'Please Complete Bank Details First', status: 'error'})
      return
    }
    if (!props?.feeData?.document_data) {
      addToast({message: 'Please Upload Documents First', status: 'error'})
      return
    }
    setOpenPaymentModal(true)

}
const handleClosePaymentDialog = () => {
  setPayableAmount(null)
  setOpenPaymentModal(false)
}
console.log("openPaymentModal",openPaymentModal)
  return (
    <>
      {(cpState?.getCPUserDetailsById?.loading || cpState?.generateCPOrder?.loading || cpState?.getCPPaymentStatus?.loading || cpState?.updateCPOrderStatus?.loading) &&
      <div>
        <Loader />
      </div>
      }
      <Box className='main_Kyc_form_container'>
        <Grid className="grid_container">
          <GridItem>
            <Heading as="h1" className="font-poppins text_subheading">To verify your details and to perform a credit underwriting, we charge a nominal registration amount. Please make this payment in order to proceed further and finish your registration process.</Heading>
            <Box mb={3} className='form_kyc_cp'>
              <Box className='table_wrapper'>
                <TableContainer>
                  <Table variant='simple'>
                    <Tbody>
                      <Tr>
                        <Td>Registration Fee</Td>
                        <Td>INR {props?.feeData?.registration_fee}</Td>
                      </Tr>
                      <Tr>
                        <Td>SGST (9%)</Td>
                        <Td>INR {props?.feeData?.sgst_fee}</Td>
                      </Tr>
                      <Tr>
                        <Td>CGST (9%)</Td>
                        <Td>INR {props?.feeData?.cgst_fee}</Td>
                      </Tr>
                    </Tbody>
                    <Tfoot>
                      <Tr>
                        <Th>Total Amount to be paid</Th>
                        <Th>INR {props?.feeData?.total_fee_amount}</Th>
                      </Tr>
                    </Tfoot>
                  </Table>
                </TableContainer>
              </Box>
            </Box>
          </GridItem>
        </Grid>
        <Box className="kyc_actions">
          {props?.feeData?.registration_fee_status === 1 ?
            <CustomButton size="md" type="submit" title={'Paid ₹ ' + props?.feeData?.total_fee_amount} className="btn_green font-poppins" isDisabled={true} /> :
            <CustomButton size="md" type="submit" title={'Pay Now ₹ ' + props?.feeData?.total_fee_amount} className="btn_green font-poppins" onClick={()=>handleAddFundsDialog()} />
          }
            <ChannelParFeePayDiag openPayModal={openPaymentModal} user_id_reg={user_id_reg} userData ={userData}  handleClosePaymentDialog={handleClosePaymentDialog}
           payableAmount={amount}
           />
        </Box>
      </Box>
    </>
  )
}
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(ActionCreators, dispatch),
})

export default connect(null, mapDispatchToProps)(OnBoardFeePayment)